import { createApp } from 'vue'
import { store } from './store/index'
import App from './App.vue'
import router from './router'
import './assets/css/gdq_web.css'
import './assets/css/gdqfont.css'
import './assets/custom.scss'
// Bootstrap JavaScript
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// Base components
import BaseComponents from './components/base'
// Date picker (used by BaseDatePicker)
import { VueDatePicker } from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
// import MaintenanceMode from './components/MaintenanceMode'
// ------------------
// Fontawesome Icons
// ------------------
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Add FontAwesome icons to library
library.add(fas, far)

// Create Vue app
const app = createApp(App)

// Use plugins
app.use(store)
app.use(router)
app.use(BaseComponents)

// Register global components
app.component('fa-icon', FontAwesomeIcon)
app.component('VueDatePicker', VueDatePicker)

// Mount app
app.mount('#app')
